import { render, staticRenderFns } from "./m-product-option-bundle.vue?vue&type=template&id=1fbba45e&scoped=true&"
import script from "./m-product-option-bundle.vue?vue&type=script&lang=js&"
export * from "./m-product-option-bundle.vue?vue&type=script&lang=js&"
import style0 from "./m-product-option-bundle.vue?vue&type=style&index=0&id=1fbba45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbba45e",
  null
  
)

export default component.exports